/**
 * 数値定数の型
 */
// interface NumberConst {
//     [key: string]: number;
// }
/**
* 文字列定数の型
*/
interface StringConst {
    [key: string]: string;
}

/**
* 定数定義
*/
export default class SystemConst {
    /**
     * テーブル項目桁数定義
     * テーブル名（キャメルケース）+'MaxLength'とする。
     * キーの名称はテーブルのカラム名に合わせる。
     *
     * 使用例：
     * -----------------------------------------------------
     * [hoge.ts]
     * import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
     * import SystemConst from '@/shared/system-const';
     *
     * ＠Component
     * export default class hoge extends Vue {
     *     // テンプレート(.vue)で使用する場合はメンバ変数に入れて使用する。
     *     private systemConst: typeof SystemConst = SystemConst;
     *     // tsファイルの中ではSystemConstを直接参照できます。
     *     private groupNameMaxLength: number = SystemConst.groupMaxLength.groupName;
     * }
     * -----------------------------------------------------
     */

    /**
     * APIパラメータ共通定義（一覧取得系APIの共通パラメータ）
     */
    public static readonly LIST_API_PARAM: StringConst = {
        SORT_KEY: 'sortKey',                    // ソートキー
        SORT_ORDER: 'sortOrder',                // ソート順
        PAGE: 'page',                           // ページ番号
        ITEMS_PER_PAGE: 'itemsPerPage',         // 1ページあたりの行数
    };

    /**
     * APIパラメータ共通定義（ソート順）
     */
    public static readonly SORT_ORDER: StringConst = {
        ASC: 'asc',                             // 昇順
        DESC: 'desc',                           // 降順
    };

    /**
     * APIパラメータ共通定義（ソート順）
     */
    public static readonly SORT_ORDER_MAPPING: string[] = [
        SystemConst.SORT_ORDER.ASC,
        SystemConst.SORT_ORDER.DESC
    ];
}
